export default "__VITE_ASSET__IUFdtn9i__"